import React from 'react'
import ReactDOM from 'react-dom'
// import * as Sentry from '@sentry/react'
// import { Integrations } from '@sentry/tracing'
import WebApp from './web'
import * as serviceWorker from './serviceWorker'
import reportWebVitals from './reportWebVitals'

// if (process.env.REACT_APP_DEP !== 'dev') {
//   Sentry.init({
//     dsn: 'http://c906e5beb40e4bf296540532571d630b@123.56.241.157:9000/5',
//     integrations: [new Integrations.BrowserTracing()], // Set tracesSampleRate to 1.0 to capture 100% // of transactions for performance monitoring. // We recommend adjusting this value in production
//     release: process.env.REACT_APP_VERSION,
//     tracesSampleRate: 1.0,
//   })
// }

ReactDOM.render(
  <React.StrictMode>
    <WebApp />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
